import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../../components/Icon/Icon";
import Checkmark from "../../icons/checkmark-round.svg";
import Information from "../../icons/information.svg";
import styles from "./Notification.module.scss";
export const Notification = ({ children, iconClassName = "", className = "", variant = "checkmark", showIcon = true, }) => {
    const iconComponent = {
        checkmark: Checkmark,
        error: Information,
        info: Information,
    };
    return (_jsxs("div", { className: `${styles.wrap} ${className} ${styles["variant-" + variant]}`, children: [showIcon && (_jsx(Icon, { component: iconComponent[variant], className: `${styles.icon} ${iconClassName}`, width: "35px", height: "35px" })), children] }));
};
//# sourceMappingURL=Notification.js.map